import { createRouter, createWebHistory } from '@ionic/vue-router';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/components/Home/HomePage'),
    },
    {
      path: '/specials',
      name: 'specials',
      component: () => import('@/components/Special/SpecialsPage'),
    },
    {
      path: '/rallys',
      name: 'rallys',
      component: () => import('@/components/Rally/RallysPage'),
    },
    {
      path: '/rally/:rallyID',
      name: 'rally',
      component: () => import('@/components/Rally/RallyPage'),
      props: true,
    },
    {
      path: '/auth',
      name: 'auth',
      component: () => import('@/components/Auth/AuthPage'),
    },
    {
      path: '/admins',
      name: 'admins',
      component: () => import('@/components/Admin/AdminsPage'),
    },
    {
      path: '/moderators',
      name: 'moderators',
      component: () => import('@/components/Moderator/ModeratorsPage'),
    },
    {
      path: '/moderator/:moderatorID',
      name: 'moderator',
      component: () => import('@/components/Moderator/ModeratorPage'),
      props: true,
    },
    {
      path: '/companies',
      name: 'companies',
      component: () => import('@/components/Company/CompaniesPage'),
    },
    {
      path: '/company-import',
      name: 'companyImport',
      component: () => import('@/components/Company/CompanyImportPage.vue'),
    },
    {
      path: '/company/:companyID',
      name: 'company',
      component: () => import('@/components/Company/CompanyPage.vue'),
      props: true,
    },
    {
      path: '/deal-image-prompts',
      name: 'dealImagePrompts',
      component: () => import('@/components/DealImagePrompt/DealImagePromptTemplatesPage'),
    },
    {
      path: '/deal-image-library-upload',
      name: 'dealImageLibraryUpload',
      component: () => import('@/components/DealImageLibrary/DealImageLibraryUploadPage'),
    },
    {
      path: '/deal-templates',
      name: 'dealTemplates',
      component: () => import('@/components/DealTemplate/DealTemplatesPage'),
    },
    {
      path: '/categories',
      name: 'categories',
      component: () => import('@/components/Category/CategoriesPage'),
    },
    {
      path: '/rally-categories',
      name: 'rallyCategories',
      component: () => import('@/components/RallyCategory/RallyCategoriesPage'),
    },
    {
      path: '/user-segments',
      name: 'userSegments',
      component: () => import('@/components/UserSegment/UserSegmentsPage'),
    },
    {
      path: '/special/:specialID',
      name: 'special',
      component: () => import('@/components/Special/SpecialPage'),
      props: true,
    },
    {
      path: '/events',
      name: 'events',
      component: () => import('@/components/Event/EventsPage'),
    },
    {
      path: '/event/:eventID',
      name: 'event',
      component: () => import('@/components/Event/EventPage'),
      props: true,
    },
    {
      path: '/reviews',
      name: 'reviews',
      component: () => import('@/components/Review/ReviewsPage.vue'),
    },
    {
      path: '/notifications',
      name: 'notifications',
      component: () => import('@/components/Settings/NotificationsSettingsPage.vue'),
    },
    {
      path: '/profile-change-review/:token',
      name: 'profileChangeReview',
      component: () => import('@/components/ProfileChange/ProfileChangeReviewPage.vue'),
      props: true,
    },
    {
      path: '/member-reports',
      name: 'memberReports',
      component: () => import('@/components/MemberReport/MemberReportsPage.vue'),
    },
    {
      path: '/support',
      name: 'supportInbox',
      component: () => import('@/components/Support/SupportInboxPage.vue'),
    },
    {
      path: '/support/:userID',
      name: 'supportThread',
      component: () => import('@/components/Support/SupportThreadPage.vue'),
      props: true,
    },
    {
      path: '/member-report-review/:token',
      name: 'memberReportReview',
      component: () => import('@/components/MemberReport/MemberReportReviewPage.vue'),
      props: true,
    },
    {
      path: '/member-report-appeal/:token',
      name: 'memberReportAppeal',
      component: () => import('@/components/MemberReport/MemberReportAppealPage.vue'),
      props: true,
    },
    {
      path: '/member-report-reasons',
      name: 'memberReportReasons',
      component: () => import('@/components/MemberReport/MemberReportReasonsPage.vue'),
    },
    {
      path: '/partner-points-settings',
      name: 'partnerPointsSettings',
      component: () => import('@/components/Settings/PartnerPointsSettingsPage.vue'),
    },
    {
      path: '/member-points-settings',
      name: 'memberPointsSettings',
      component: () => import('@/components/Settings/MemberPointsSettingsPage.vue'),
    },
    {
      path: '/invitation-settings',
      name: 'invitationSettings',
      component: () => import('@/components/Settings/InvitationSettingsPage.vue'),
    },
    {
      path: '/invitation-quota-campaign',
      name: 'invitationQuotaCampaign',
      component: () => import('@/components/Settings/InviteQuotaCampaignPage.vue'),
    },
    {
      path: '/invitation-registration-unlock',
      name: 'invitationRegistrationUnlock',
      component: () => import('@/components/Settings/RegistrationUnlockPage.vue'),
    },
    {
      path: '/invitation-codes',
      name: 'invitationCodes',
      component: () => import('@/components/Settings/AdminInviteCodesPage.vue'),
    },
    {
      path: '/invitation-codes/:id',
      name: 'invitationCodeDetail',
      component: () => import('@/components/Settings/AdminInviteCodeDetailPage.vue'),
    },
    {
      path: '/invitation-code-batches',
      name: 'invitationCodeBatches',
      component: () => import('@/components/Settings/AdminInviteCodeBatchesPage.vue'),
    },
    {
      path: '/invitation-code-batches/:id',
      name: 'invitationCodeBatchDetail',
      component: () => import('@/components/Settings/AdminInviteCodeBatchDetailPage.vue'),
    },
    {
      path: '/partner-invoices',
      name: 'partnerInvoices',
      component: () => import('@/components/Settings/PartnerInvoicesPage.vue'),
    },
    {
      path: '/partner-commission-settings',
      name: 'partnerCommissionSettings',
      component: () => import('@/components/Settings/PartnerCommissionSettingsPage.vue'),
    },
    {
      path: '/user-company-visibility-filter',
      name: 'userCompanyVisibilityFilter',
      component: () => import('@/components/Settings/UserCompanyVisibilityFilterSettingsPage.vue'),
    },
    {
      path: '/marketing',
      name: 'marketing',
      component: () => import('@/components/Settings/MarketingPage.vue'),
    },
    {
      path: '/potential-deal-savings',
      redirect: { path: '/marketing', query: { tab: 'catalog' } },
    },
    {
      path: '/partner-active-deal-limit-settings',
      name: 'partnerActiveDealLimitSettings',
      component: () => import('@/components/Settings/PartnerActiveDealLimitSettingsPage.vue'),
    },
    {
      path: '/promoters',
      name: 'promoters',
      component: () => import('@/components/Promoter/PromotersPage.vue'),
    },
    {
      path: '/promoter-review/:token',
      name: 'promoterReview',
      component: () => import('@/components/Promoter/PromoterReviewPage.vue'),
      props: true,
    },
    {
      path: '/promoter-points-settings',
      name: 'promoterPointsSettings',
      component: () => import('@/components/Settings/PromoterPointsSettingsPage.vue'),
    },
    {
      path: '/crew',
      name: 'crew',
      component: () => import('@/components/Crew/CrewPage.vue'),
    },
    {
      path: '/crew-review/:token',
      name: 'crewReview',
      component: () => import('@/components/Crew/CrewReviewPage.vue'),
      props: true,
    },
    {
      path: '/rally-blacklist',
      name: 'rallyBlacklist',
      component: () => import('@/components/Crew/RallyBlacklistPage.vue'),
    },
    {
      path: '/crew-reports',
      name: 'crewReports',
      component: () => import('@/components/Crew/CrewReportsPage.vue'),
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('@/components/User/UsersPage'),
    },
    {
      path: '/user/:userID',
      name: 'user',
      component: () => import('@/components/User/UserPage'),
      props: true,
    },
  ],
});

export default router;
